import { Validator } from "vee-validate";
import Moment from "moment";

Validator.extend("cpf", {
  validate: cpf => {
    const num = cpf.replace(/[^\d]+/g, "");
    if (
      !num ||
      num.length != 11 ||
      num == "00000000000" ||
      num == "11111111111" ||
      num == "22222222222" ||
      num == "33333333333" ||
      num == "44444444444" ||
      num == "55555555555" ||
      num == "66666666666" ||
      num == "77777777777" ||
      num == "88888888888" ||
      num == "99999999999"
    ) {
      return false;
    }

    let soma = 0;

    let resto;

    for (let i = 1; i <= 9; i++) {
      soma += parseInt(num.substring(i - 1, i)) * (11 - i);
    }

    resto = (soma * 10) % 11;

    if (resto == 10 || resto == 11) resto = 0;
    if (resto != parseInt(num.substring(9, 10))) return false;
    soma = 0;
    for (let i = 1; i <= 10; i++) {
      soma += parseInt(num.substring(i - 1, i)) * (12 - i);
    }
    resto = (soma * 10) % 11;
    if (resto == 10 || resto == 11) resto = 0;
    if (resto != parseInt(num.substring(10, 11))) return false;
    return true;
  }
});

Validator.extend("cnpj", {
  validate: cnpj => {
    const num = cnpj.replace(/[^\d]+/g, "");
    if (
      !num ||
      num.length != 14 ||
      num == "00000000000000" ||
      num == "11111111111111" ||
      num == "22222222222222" ||
      num == "33333333333333" ||
      num == "44444444444444" ||
      num == "55555555555555" ||
      num == "66666666666666" ||
      num == "77777777777777" ||
      num == "88888888888888" ||
      num == "99999999999999"
    ) {
      return false;
    }
    let tamanho = num.length - 2;
    let numeros = num.substring(0, tamanho);
    const digitos = num.substring(tamanho);
    let soma = 0;
    let pos = tamanho - 7;
    for (let i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;
      if (pos < 2) pos = 9;
    }
    let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
    if (resultado != digitos.charAt(0)) return false;
    tamanho += 1;
    numeros = num.substring(0, tamanho);
    soma = 0;
    pos = tamanho - 7;
    for (let i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;
      if (pos < 2) pos = 9;
    }
    resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
    if (resultado != digitos.charAt(1)) return false;
    return true;
  }
});

Validator.extend("date", {
  validate: date => {
    if (Moment(date, "DDMMYYYY").isValid()) return true;
    return false;
  }
});

Validator.extend("email_confirmation", {
  validate: (email_confirmation, args) => {
    if (email_confirmation === args[0]) return true;
    return false;
  }
});

Validator.extend("pis_nis", {
  validate: pis => {
    const num = pis.replace(/[^\d]+/g, "");
    const multiplicadorBase = "3298765432";

    let iSoma = 0;
    let iResto = 0;
    let iDV = 99;

    let multiplicando = 0;
    let multiplicador = 0;
    let iDVInformado = 99;

    let i;
    let iRet = 0;

    if (num.length != 11 || num == "00000000000") {
      iRet = iRet--;
    } else {
      for (i = 0; i < 10; i++) {
        multiplicando = parseInt(num.substring(i, i + 1));
        multiplicador = parseInt(multiplicadorBase.substring(i, i + 1));

        iSoma += multiplicando * multiplicador;
      }

      iResto = iSoma % 11;
      if (iResto > 0) {
        iDV = 11 - iResto;
      } else {
        iDV = 0;
      }

      iDVInformado = parseInt(num.substring(10, 11));
      if (iDV != iDVInformado) {
        iRet--;
      }
    }

    return iRet == 0;
  }
});
